import { useCallback, useEffect, useState } from "react";
import { getAllCities_V2 } from "../Services_V2/City.service";
import { ICity, SelectOption } from "../types";
import { showError } from "../utils/error";

export const useCities = () => {
    const [options, setOptions] = useState<SelectOption[]>([]);
    const [map, setMap] = useState<Map<string, string>>(new Map());
    const [loading, setLoading] = useState(true);

    const fetch = useCallback(async () => {
        try {
            setLoading(true);
            const res = await getAllCities_V2();
            const cities: ICity[] = res?.data ?? [];

            const opts = cities?.map(({ _id, city }) => ({ label: city, value: _id }));
            const nameMap = new Map<string, string>();
            cities?.forEach(c => nameMap.set(c._id, c.city));

            setOptions(opts);
            setMap(nameMap);
        } catch (error) {
            showError(error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetch();
    }, [fetch]);

    return { options, map, loading, refetch: fetch };
};